export enum AudioTrack {
  Stereo12 = '12',
  Stereo34 = '34',
  Stereo56 = '56',
  Stereo78 = '78',
  Mono1 = '1',
  Mono2 = '2',
  Mono3 = '3',
  Mono4 = '4',
  Mono5 = '5',
  Mono6 = '6',
  Mono7 = '7',
  Mono8 = '8',
}
